@if (control && columnItems().length > 0) {
    <arc-button-toggle-group [control]="control | formControl" [items]="columnItems()" class="h-full w-full" />
}
